export function getSignalStrength(rssi) {
  if (rssi >= -80) return 'Strong';
  return 'Okay';
}

export function getBatteryLevel(batteryLevel) {
  if (batteryLevel <= 30) return 'Low';
  if (batteryLevel <= 60) return 'Ok';
  return 'Good';
}

export function getSecondsElapsed(unixTimestamp) {
  const currentUnixTime = Math.floor(Date.now() / 1000);
  return currentUnixTime - unixTimestamp;
}

export function unixTimePassed(unixTimestamp) {
  const secondsElapsed = getSecondsElapsed(unixTimestamp);
  if (secondsElapsed < 120) {
    return '';
  }
  // if (secondsElapsed < 60) {
  //   return `${secondsElapsed} Sec Ago`;
  // }
  if (secondsElapsed < 3600) {
    return `${Math.floor(secondsElapsed / 60)} Min Ago`;
  }
  if (secondsElapsed < 86400) {
    return `${Math.floor(secondsElapsed / 3600)} Hr Ago`;
  }
  if (secondsElapsed < 604800) {
    return `${Math.floor(secondsElapsed / 86400)} Days Ago`;
  }
  if (secondsElapsed < 31449600) {
    return `${Math.floor(secondsElapsed / 604800)} Wks Ago`;
  }

  return `${Math.floor(secondsElapsed / 31449600)} Yrs Ago`;
}
